import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'

const WebpImage = React.memo(({ src, alt, width, height, ...props }) => (
    <LazyLoadImage
        src={src}
        alt={alt}
        width={width}
        height={height}
        effect="blur"
        placeholderSrc={src}
        {...props}
    />
))

WebpImage.displayName = 'WebpImage'

export default WebpImage
